/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { ProductPurchaseConfirmDownloadResponseDto } from '../models/product-purchase-confirm-download-response-dto';
import { productPurchaseControllerConfirmDownload } from '../fn/product-purchase/product-purchase-controller-confirm-download';
import { ProductPurchaseControllerConfirmDownload$Params } from '../fn/product-purchase/product-purchase-controller-confirm-download';
import { productPurchaseControllerSearch } from '../fn/product-purchase/product-purchase-controller-search';
import { ProductPurchaseControllerSearch$Params } from '../fn/product-purchase/product-purchase-controller-search';
import { productPurchaseControllerSearchByAdmin } from '../fn/product-purchase/product-purchase-controller-search-by-admin';
import { ProductPurchaseControllerSearchByAdmin$Params } from '../fn/product-purchase/product-purchase-controller-search-by-admin';
import { SearchProductPurchaseResponseDto } from '../models/search-product-purchase-response-dto';

@Injectable({ providedIn: 'root' })
export class ProductPurchaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productPurchaseControllerSearch()` */
  static readonly ProductPurchaseControllerSearchPath = '/api/product-purchase/user';

  /**
   * Search product purchase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productPurchaseControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  productPurchaseControllerSearch$Response(params: ProductPurchaseControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchProductPurchaseResponseDto>> {
    return productPurchaseControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Search product purchase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productPurchaseControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productPurchaseControllerSearch(params: ProductPurchaseControllerSearch$Params, context?: HttpContext): Observable<SearchProductPurchaseResponseDto> {
    return this.productPurchaseControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchProductPurchaseResponseDto>): SearchProductPurchaseResponseDto => r.body)
    );
  }

  /** Path part for operation `productPurchaseControllerSearchByAdmin()` */
  static readonly ProductPurchaseControllerSearchByAdminPath = '/api/product-purchase/admin';

  /**
   * Search product purchase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productPurchaseControllerSearchByAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  productPurchaseControllerSearchByAdmin$Response(params: ProductPurchaseControllerSearchByAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return productPurchaseControllerSearchByAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * Search product purchase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productPurchaseControllerSearchByAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productPurchaseControllerSearchByAdmin(params: ProductPurchaseControllerSearchByAdmin$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.productPurchaseControllerSearchByAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `productPurchaseControllerConfirmDownload()` */
  static readonly ProductPurchaseControllerConfirmDownloadPath = '/api/product-purchase/download';

  /**
   * Get product purchase count.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productPurchaseControllerConfirmDownload()` instead.
   *
   * This method doesn't expect any request body.
   */
  productPurchaseControllerConfirmDownload$Response(params: ProductPurchaseControllerConfirmDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductPurchaseConfirmDownloadResponseDto>> {
    return productPurchaseControllerConfirmDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * Get product purchase count.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productPurchaseControllerConfirmDownload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productPurchaseControllerConfirmDownload(params: ProductPurchaseControllerConfirmDownload$Params, context?: HttpContext): Observable<ProductPurchaseConfirmDownloadResponseDto> {
    return this.productPurchaseControllerConfirmDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductPurchaseConfirmDownloadResponseDto>): ProductPurchaseConfirmDownloadResponseDto => r.body)
    );
  }

}
